import { render, staticRenderFns } from "./addAlarm.vue?vue&type=template&id=125efe6a&scoped=true"
import script from "./addAlarm.vue?vue&type=script&lang=js"
export * from "./addAlarm.vue?vue&type=script&lang=js"
import style0 from "./addAlarm.vue?vue&type=style&index=0&id=125efe6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125efe6a",
  null
  
)

export default component.exports